<script lang="ts">
  import type { WithElementRef, WithoutChildren } from "bits-ui"
  import type { HTMLAttributes } from "svelte/elements"
  import { cn } from "$lib/utils.js"

  let {
    ref = $bindable(null),
    class: className,
    ...restProps
  }: WithoutChildren<WithElementRef<HTMLAttributes<HTMLDivElement>>> = $props()
</script>

<div
  bind:this={ref}
  class={cn("bg-primary/10 animate-pulse rounded-md", className)}
  {...restProps}
></div>
